import React from "react";
import {
  InvoiceArrival,
  InvoiceArrivalItem,
} from "@towersystems/roam-common/lib/generated-types";

export type ActiveInvoiceArrivalType = {
  invoiceArrival: InvoiceArrival;
  setInvoiceArrival: (invoiceArrival: InvoiceArrival) => void;
};

export type ActiveInvoiceArrivalItemType = {
  item: InvoiceArrivalItem;
};

export const ActiveInvoiceArrivalContext = React.createContext<
  ActiveInvoiceArrivalType | undefined
>(undefined);

export const ActiveInvoiceArrivalItemContext = React.createContext<
  ActiveInvoiceArrivalItemType | undefined
>(undefined);
